import AdminDashboard from "../AdminPages/Dashboard/AdminDashboard";
import AdminHome from "../layouts/AdminLayout";

import { Navigate } from "react-router-dom";
import route from "./routeNames";

import Categories from "../AdminPages/Categories";
import Degrees from "../AdminPages/Degrees";
import DocumentLookUp from "../AdminPages/DocumentLookUp";
import EducationEssentials from "../AdminPages/EducationHistory";
import FAQCategory from "../AdminPages/FAQCategory";
import FAQs from "../AdminPages/FAQs";
import Industries from "../AdminPages/Industries";
import IndustryTypes from "../AdminPages/IndustryTypes";
import Interests from "../AdminPages/Interests";
import Jobs from "../AdminPages/Jobs";
import LookupList from "../AdminPages/lookuplist";
import Major from "../AdminPages/Major";
import Minor from "../AdminPages/Minor";
import Skills from "../AdminPages/Skills";
import SkillsAndMore from "../AdminPages/Skills&More";
import WebLinkLookUps from "../AdminPages/WebLinkLookUps";
import ViewUsers from "../AdminPages/Users";
import EditProfile from "../AdminPages/Settings/editProfile";
import ProfileInformation from "../AdminPages/ProfileInformation";

export const admin = {
  // path: "/admin",
  // element: <RequireAuth />,
  // children: [
  //   {
  path: "/admin/",
  // element: <GeneralLayout />,
  element: <AdminHome />,

  children: [
    // { path: "/", element: <Navigate to={routeNames.general.landing} /> },
    { path: route.admin.dashboard, element: <AdminDashboard /> },
    // { path: route.admin.userRoles, element: <ViewRoles /> },
    // { path: route.admin.addUsers, element: <AddUsers /> },
    // {
    //   path: route.admin.viewAdmins,
    //   element: <ViewUsers userType={"Admins"} />,
    // },
    // {
    //   path: route.admin.viewCompanies,
    //   element: <ViewUsers userType={"Companies"} />,
    // },
    // {
    //   path: route.admin.viewJobSeekers,
    //   element: <ViewUsers userType={"Job Seekers"} />,
    // },
    { path: route.admin.categories, element: <Categories /> },
    { path: route.admin.skills, element: <Skills /> },
    { path: route.admin.industryTypes, element: <IndustryTypes /> },
    { path: route.admin.industries, element: <Industries /> },
    { path: route.admin.degrees, element: <Degrees /> },
    { path: route.admin.interests, element: <Interests /> },
    { path: route.admin.majors, element: <Major /> },
    { path: route.admin.minors, element: <Minor /> },
    { path: route.admin.FAQ, element: <FAQs /> },
    { path: route.admin.FAQCategory, element: <FAQCategory /> },
    { path: route.admin.lookups, element: <LookupList /> },
    { path: route.admin.jobs, element: <Jobs /> },
    { path: route.admin.viewUsers, element: <ViewUsers /> },
    { path: route.admin.education, element: <EducationEssentials /> },
    { path: route.admin.employmentHistory, element: <Industries /> },
    { path: route.admin.skillsAndMore, element: <SkillsAndMore /> },
    { path: route.admin.profileInformation, element: <ProfileInformation /> },
    {
      path: route.admin.documentLookups,
      element: <DocumentLookUp />,
    },
    {
      path: route.admin.webLinkLookups,
      element: <WebLinkLookUps />,
    },
    {
      path: route.admin.editProfile,
      element: <EditProfile />,
    },
    { path: "*", element: <Navigate to={route.admin.dashboard} /> },
  ],
  // },
  // ],
};
